/* Approvals Page */
.approvals-page-heading {
    padding-bottom: var(--spacing-4xl);
}

.approvals-page-content {
    padding: var(--spacing-4xl);
    padding-bottom: 0;
    overflow: hidden;

    .checkbox {
        cursor: pointer;
        &.checkbox-medium {
            .check-mark {
                transition: box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out;

                svg {
                    stroke-width: 3px !important;
                }

                &:hover {
                    box-shadow: 0 0 3px 5px var(--grey-50);
                }
            }
        }
    }

    .approval-table {
        .table {
            tr {
                td {
                    padding: 0 !important;
                    height: 1px;
                }
            }
            tr.table-row-selected-approval {
                td {
                    background-color: var(--menu-bg-color-hover) !important;
                }
            }
        }
    }
    
    .approval-table-cell-clickable {
        cursor: pointer;
        display: block;
        min-block-size: 100%;
        padding: var(--cell-padding);

        &-disabled {
            cursor: default;
        }
    }
}

.approvals-page-footer {
    box-shadow: 0 -5px 10px -3px rgba(0, 0, 0, 0.1);
}

.display-user-wrapper.comment-row {
    align-items: flex-start;
    font-size: 14px;

    .comment-sender-name {
        white-space: nowrap;
        overflow: hidden;
    }

    .comment-content {
        overflow-wrap: break-word;
        word-break: break-word;
        white-space: normal;

        p {
            margin: 0;
        }
    }
}


.min-w-0 {
    min-width: 0;
}

.approval-modal-comment-container {
    background-color: var(--background-white-color);
}

.modal-overlay-approval-modal {
    .modal {
        &-body {
            background-color: var(--body-background-color);
        }

        &-footer {
            padding-top: var(--spacing-3xl) !important;
        }
    }

}
